import React, { PropsWithChildren } from "react";

import { makeSvgDataSrc } from "../helper/makeSvgData";

const getDimensions = (unitId: string) => {
  switch (unitId) {
    case "lb1":
    case "lb2":
    case "lb3":
      return { width: 728, height: 90 };
    default:
      return { width: 300, height: 250 };
  }
};

function createAdUnit(unitId: string): React.FC<PropsWithChildren> {
  const dimensions = getDimensions(unitId);

  const Component = ({ children }: PropsWithChildren) => (
    <div data-placeholder={unitId}>
      <div>
        <img
          style={{ maxWidth: "100%" }}
          src={makeSvgDataSrc({
            ...dimensions,
            text: `Ad: ${unitId}`.toUpperCase(),
          })}
          alt={`Ad-${unitId}`}
        />
      </div>
      {children}
    </div>
  );

  Component.displayName = `Ad-${unitId}`;
  return Component;
}

export const SvgAdsLb1 = createAdUnit("lb1");

export const SvgAdsLb2 = createAdUnit("lb2");

export const SvgAdsLb3 = createAdUnit("lb3");

export const SvgAdsImu1 = createAdUnit("imu1");

export const SvgAdsImu2 = createAdUnit("imu2");

export const SvgAdsMidarticleSpecial = createAdUnit("midarticlespecial");
